import React, { useRef, useEffect, useState } from "react";

import img_bbps from "../../Assets/img_bbps_ .webp";
import img_virtual_account_qr_code from "../../Assets/img_virtual_account_qr_code_ .webp";
import img_identity_verification from "../../Assets/img_identity_verification_.webp";

const data = [
  {
    title: "Bharat Bill Payment System (BBPS)",
    desc: "Bumppy Bill Payment Services For Retailers Are Profitable And Easy to use. Just keeping track of all the bills that need to be paid and then going to pay them is, at best, a major time-consuming task for the average person.",
    image: img_bbps,
  },
  {
    title: "Virtual Account/QR Code",
    desc: "You may obtain payer information and maintain track of Payment to numerous electronic and paper accounts in a consistent way with the help of our Virtual Account Collection services.",
    image: img_virtual_account_qr_code,
  },
  {
    title: "Identity Verification",
    desc: "Bumppy Payments service improved the online identity verification process. User can Prevent online identity fraud and identity theft, and simplify KYC/AML compliance while providing a easy onboarding experience.",
    image: img_identity_verification,
  },
];

export default function TransactionFeatures() {
  const [active, setActive] = useState(0);
  const [progress, setProgress] = useState(0);
  const isAuto = useRef(true);

  useEffect(() => {
    setProgress(0);
    isAuto.current = true;

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 40);

    return () => clearInterval(interval);
  }, [active]);

  useEffect(() => {
    if (progress === 100 && isAuto.current) {
      const timeout = setTimeout(() => {
        setActive((prev) => (prev < data.length - 1 ? prev + 1 : 0));
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [progress]);

  const handleClick = (index) => {
    isAuto.current = false;
    setActive(index);
    setProgress(0);
  };

  return (
    <section className="bg-[#ffffff] py-16 md:py-24 font-inter px-6 md:px-0 ">
      <header className="text-center max-w-3xl mx-auto">
        <h2 className="font-spacegrotesk text-2xl sm:text-3xl md:text-4xl lg:text-[48px] font-semibold text-[#151515] leading-snug">
          Start Growing Online with Low <br className="hidden sm:block" />
          Transaction Costs
        </h2>
      </header>

      <div className="grid md:grid-cols-2 grid-cols-1 items-start mx-auto max-w-6xl gap-10 sm:px-8 md:px-0 mt-10 py-10">
        <div className="space-y-6">
          {data.map((item, index) => (
            <div key={index} className="pb-4 ">
              <h3
                onClick={() => handleClick(index)}
                className={`cursor-pointer font-spacegrotesk font-semibold text-xl md:text-3xl transition-colors duration-300 ${
                  active === index
                    ? "text-black"
                    : "text-gray-400 hover:text-gray-600"
                }`}
              >
                {item.title}
              </h3>

              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  active === index
                    ? "max-h-[500px] mt-4 opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <p className="font-spacegrotesk text-lg text-gray-600 leading-relaxed mb-4">
                  {item.desc}
                </p>

                <div className="w-full h-1.5 bg-gray-100 overflow-hidden rounded-full">
                  <div
                    className="h-full transition-all duration-100 linear"
                    style={{
                      width: `${active === index ? progress : 0}%`,
                      background:
                        "linear-gradient(90deg, #4C1FFF, #FF7474, #E4E4E4)",
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="relative w-full h-[350px] sm:h-[450px] md:h-[500px] flex items-center justify-center overflow-hidden bg-transparent">
          {data.map((item, index) => (
            <img
              key={index}
              src={item.image}
              alt={item.title}
              className={`absolute max-w-full max-h-full w-auto h-auto object-contain transition-all duration-700 ease-in-out ${
                active === index
                  ? "opacity-100 translate-y-0 scale-100 z-10"
                  : "opacity-0 translate-y-8 scale-90 z-0 pointer-events-none"
              }`}
              style={{
                aspectRatio: "attr(width) / attr(height)",
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
